// IMPORT
    // MODULE(S)
        import React from 'react';
        import PropTypes from 'prop-types';
        import { sortableContainer } from 'react-sortable-hoc';
        import arrayMove from 'array-move';
    // STYLE(S)
        import '../sass/TodoList.scss';
    // COMPONENT(S)
        import Todo from './Todo';



// EXTERNAL CONTENT
    // TOOL : sortableContainer => Info : To drag and drop todos and sort them
        const SortableContainer = sortableContainer(({ list, toggleTodo, clearTodo, modifyTodo }) => {
            return (
                <ul>
                {list.map((todo, index) => (
                    <Todo key={todo.id} index={index} todo={todo} toggleTodo={toggleTodo} clearTodo={clearTodo} modifyTodo={modifyTodo} />
                ))}
                </ul>
            );
        });



// MAIN CONTENT - FUNCTION / COMPONENT
    function TodoList({ list, updateList, toggleTodo, clearTodo, modifyTodo }) {


        // TOOL : onSortEnd Event + arrayMove => Info : To switch index between sortable elements
            const onSortEnd = ({oldIndex, newIndex}) => {
                updateList(arrayMove(list, oldIndex, newIndex));
            }

        // VARIABLE(S)
            const todo_total = list.length;
            let content, className;


        // DILEMMA(S)
            if (todo_total > 0) {
                content = <SortableContainer list={list} onSortEnd={onSortEnd} useDragHandle helperClass={'SortableHelper'} toggleTodo={toggleTodo} clearTodo={clearTodo} modifyTodo={modifyTodo} />;
                className = "todoList";
            } else {
                content =
                    <p className="error404">
                        <span>No task(s) found !</span><br />
                        <span>Please add a new task.</span>
                    </p>;
                // className = "todoList none";
                className = "todoList";
            }


        // RETURN
            return (
                <div className={className} >
                    {content}
                </div>
            )
    }
    export default TodoList;



// PROPTYPES
    TodoList.propTypes = {
        list: PropTypes.array,
        updateList: PropTypes.func,
        toggleTodo: PropTypes.func,
        clearTodo: PropTypes.func,
        modifyTodo: PropTypes.func
    }
